const BASEURL ="https://quizebackend.onrender.com";
// const BASEURL= "http://localhost:4000";
export default BASEURL;